export type UserRole = 'owner' | 'edit' | 'view';
export type MemberStatus = 'pending' | 'active';
export type ItemType = 'vehicle' | 'appliance';
export type FileKind = 'invoice' | 'warranty' | 'certificate' | 'other';
export type RepeatUnit = 'days' | 'weeks' | 'months' | 'years';

export interface Profile {
  id: string;
  email: string;
  display_name: string | null;
  created_at?: string;
}

export interface Family {
  id: string;
  name: string;
  owner_id: string;
  created_at: string;
}

export interface Member {
  id: string;
  family_id: string;
  user_id: string | null;
  invited_email: string;
  role: 'view' | 'edit';
  status: MemberStatus;
  created_at: string;
  profiles?: Profile | null;
}

export interface Item {
  id: string;
  family_id: string;
  type: ItemType;
  name: string;
  brand: string | null;
  model: string | null;
  serial_or_reg_no: string | null;
  purchase_date: string | null;
  store: string | null;
  price: number | null;
  warranty_end: string | null;
  notes: string | null;
  created_by: string;
  created_at: string;
}

export interface Reminder {
  id: string;
  item_id: string;
  family_id: string;
  title: string;
  repeat_every: number;
  repeat_unit: RepeatUnit;
  remind_before_days: number;
  start_date: string;
  next_due_date: string;
  is_active: boolean;
  one_time: boolean;
  last_notified_for: string | null;
  created_at?: string;
}

export interface ServiceLog {
  id: string;
  reminder_id: string | null;
  item_id: string;
  family_id: string;
  done_date: string;
  notes: string | null;
  file_path: string | null;
  created_by: string;
  created_at: string;
}

export interface FileRecord {
  id: string;
  item_id: string;
  family_id: string;
  kind: FileKind;
  storage_path: string;
  file_name: string;
  mime: string;
  created_by: string;
  created_at: string;
}

export interface PushSubscriptionRecord {
  id: string;
  user_id: string;
  endpoint: string;
  p256dh: string;
  auth: string;
  created_at: string;
}

export interface DashboardItem {
  reminder: Reminder;
  item: Item;
  daysUntilDue: number;
  isOverdue: boolean;
}

export interface ReminderFormData {
  title: string;
  repeat_every: number;
  repeat_unit: RepeatUnit;
  remind_before_days: number;
  start_date: string;
  one_time: boolean;
}

export const VEHICLE_REMINDER_PRESETS: ReminderFormData[] = [
  { title: 'Insurance Expiry', repeat_every: 1, repeat_unit: 'years', remind_before_days: 30, start_date: '', one_time: false },
  { title: 'PUC / Pollution Certificate', repeat_every: 6, repeat_unit: 'months', remind_before_days: 14, start_date: '', one_time: false },
  { title: 'Service / Oil Change', repeat_every: 6, repeat_unit: 'months', remind_before_days: 7, start_date: '', one_time: false },
  { title: 'Tyre Pressure Check', repeat_every: 1, repeat_unit: 'months', remind_before_days: 2, start_date: '', one_time: false },
  { title: 'Air Filter Cleaning', repeat_every: 3, repeat_unit: 'months', remind_before_days: 3, start_date: '', one_time: false },
  { title: 'License / RC Renewal', repeat_every: 5, repeat_unit: 'years', remind_before_days: 60, start_date: '', one_time: false },
];

export const APPLIANCE_REMINDER_PRESETS: ReminderFormData[] = [
  { title: 'Warranty Expiry', repeat_every: 1, repeat_unit: 'years', remind_before_days: 30, start_date: '', one_time: true },
  { title: 'Periodic Service', repeat_every: 1, repeat_unit: 'years', remind_before_days: 14, start_date: '', one_time: false },
];
